import React, { useRef, useState } from 'react';
import { useProject } from '../context/ProjectContext';
import LoadExportModal from '../modals/LoadExportModal';
import PrimaryButton from '../components/buttons/PrimaryButton';
import DeleteButton from '../components/buttons/DeleteButton';
import { handleExportConfiguration, handleLoadConfiguration, handleResetConfiguration } from '../utils/ProjectUtils';
import './HomePage.css';

const cloneProjectData = (projectData) => JSON.parse(JSON.stringify(projectData));

const HomePage = () => {
  const {
    verbatims,
    notes,
    slides,
    labels,
    labelTypes,
    setVerbatims,
    setNotes,
    setSlides,
    setLabels,
    setLabelTypes,
    setFilters,
  } = useProject();

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loadedData, setLoadedData] = useState(null);
  const fileInputRef = useRef(null);

  const handleFileChange = (event) => {
    const file = event.target.files?.[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e) => {
        try {
          const data = JSON.parse(e.target.result);
          setLoadedData(cloneProjectData(data));
          setIsModalOpen(true); // Open the modal
        } catch (error) {
          alert("Error parsing the file: " + error.message);
        }
      };
      reader.readAsText(file);
    }
  };

  const closeLoadFlow = () => {
    setIsModalOpen(false);
    setLoadedData(null);
  };

  const runProjectLoad = (projectData, loadOptions) => {
    handleLoadConfiguration(
      projectData,
      {
        setVerbatims,
        setNotes,
        setSlides,
        setLabels,
        setLabelTypes,
        setFilters,
      },
      (error) => alert("Error loading configuration: " + error.message),
      loadOptions
    );
    closeLoadFlow();
    setLoadedData(null);
  };


  return (
    <div className="home-page">
      <div className="left-panel">
        <div className="info-section">
          <h2>Hello there!</h2>
          <p>
            Use this tool to <strong>label verbatims</strong>, organize them into <strong>insight pages</strong>, automatically generate your <strong>quantitative charts</strong>, and more!
          </p>
        </div>
        <div className="kpi-section">
          <h4>In your project currently, there are:</h4>
          <ul>
            <li>
              <p>
                <strong>{verbatims?.length || 0}</strong> verbatims.
              </p>
            </li>
            <li>
              <p>
                <strong>{slides?.length || 0}</strong> slides.
              </p>
            </li>
          </ul>
        </div>
        <div className="version-section">
          <p>We are currently on version <strong>1.0.16</strong> of the tool.</p>
        </div>
      </div>
      <div className="right-panel">
        <div className="project-settings-container">
          <PrimaryButton onClick={() => handleExportConfiguration({ verbatims, notes, slides, labels, labelTypes })}>
            <i className="fa-solid fa-file-export"></i> Export Project
          </PrimaryButton>
          <PrimaryButton onClick={() => fileInputRef.current?.click()}>
            <i className="fa-solid fa-file-import"></i> Load Project
          </PrimaryButton>
          <DeleteButton
            onClick={() =>
              handleResetConfiguration({
                setVerbatims,
                setNotes,
                setSlides,
                setLabels,
                setLabelTypes,
              })
            }
          >
            <i className="fa-solid fa-redo"></i> Reset Project
          </DeleteButton>
          <input
            type="file"
            accept=".json"
            ref={fileInputRef}
            style={{ display: 'none' }}
            onChange={handleFileChange}
          />
        </div>
      </div>
      <LoadExportModal
        isOpen={isModalOpen}
        onClose={closeLoadFlow}
        loadedData={loadedData}
        onConfirm={({ action, selectedLabels, selectedLabelTypes, selectedSlides, projectData }) => {
          runProjectLoad(
            projectData || loadedData,
            {
              action,
              selectedLabels,
              selectedLabelTypes,
              selectedSlides,
            }
          );
        }}
      />
    </div>
  );
};

export default HomePage;
